import CollectionInterface from '@/utilities/bid/cost/Interfaces/CollectionInterface'
import CalculationResultInterface from '@/utilities/bid/cost/Interfaces/CalculationResultInterface'
import cloneDeep from 'lodash/cloneDeep'

class Calculation {
  collection: Array<CollectionInterface> = []
  calculation: number = 0
  total: number = 0.0
  manual: number = 0.0

  constructor(collection: Array<CollectionInterface>) {
    this.collection = cloneDeep(collection)
  }

  rowTotal(collection: Array<CollectionInterface>) {
    collection.forEach((item: any) => {
      item.total = parseFloat(item.rate) * parseFloat(item.calculated) + parseFloat(item.manual)
    })
  }

  columnTotal(collection: Array<CollectionInterface>) {
    let calculated: any = 0
    let total: any = 0
    let manual: any = 0

    collection.forEach((item: any) => {
      calculated = parseFloat(calculated) + parseFloat(item.calculated ?? 0)
      total = parseFloat(total) + parseFloat(item.total ?? 0)
      manual = parseFloat(manual ?? 0) + parseFloat(item.manual ?? 0)
    })

    this.calculation = calculated
    this.manual = manual
    this.total = total
  }

  all(): Array<CollectionInterface> {
    this.rowTotal(this.collection)
    this.columnTotal(this.collection)
    return this.collection
  }

  getContainerOfTotals() {
    return { key: 'total', title: 'Total', calculated: this.calculation, rate: '-', manual: this.manual, total: this.total }
  }

  getTotalValue(): number {
    return this.total
  }

  getResults(reference: string): CalculationResultInterface {
    return { ref: reference, calculated: this.calculation, manual: this.manual, total: this.total }
  }
}

export default Calculation
